import superagent from 'superagent';
import browserFetch from 'isomorphic-fetch';

export const post = (url, data = null) => (
    new Promise((resolve, reject) => {
        superagent
            .post(url)
            .send(data)
            .set('Accept', 'application/json')
            .end((error, res) => {
                error ? reject(error) : resolve(res);
            });
    })
);

export const fetch = (url) => (
    browserFetch(url, {credentials: 'include'})
);

export const simulate = (data, ms = 1000) => new Promise(
    resolve => setTimeout(() => resolve({
        json: () => data,
        ok: true
    }), ms)
);

export const simulatePost = (data, ms = 1000) => new Promise(
    resolve => setTimeout(() => resolve({
        body: data,
        ok: true
    }), ms)
);
